import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiSwitch: {
      defaultProps: {
        color: 'default',
      },
      styleOverrides: {
        root: ({ theme, ownerState }) => {
          const color = ownerState?.color ?? 'default';

          const colorStyles = {
            unchecked: {
              track: theme.palette.grey[200],
              thumb: theme.palette.common.white,
            },
            checked: {
              track: color === 'default' ? theme.palette.success.main : theme.palette[color].main,
              thumb: theme.palette.common.white,
            },
            disableUnchecked: {
              track: theme.palette.grey[200],
              thumb: theme.palette.grey[100],
            },
            disableChecked: {
              track: color === 'default' ? theme.palette.success.light : theme.palette[color].light,
              thumb: theme.palette.common.white,
            },
          };

          return {
            width: '44px',
            height: '24px',
            padding: 0,
            '& .MuiSwitch-switchBase': {
              padding: 0,
              margin: 2,
              transitionDuration: `${theme.transitions.duration.shortest}ms`,
              // Unchecked
              '& .MuiSwitch-thumb': {
                color: colorStyles.unchecked.thumb,
              },
              '& + .MuiSwitch-track': {
                backgroundColor: colorStyles.unchecked.track,
              },
              // Checked
              '&.Mui-checked': {
                transform: 'translateX(20px)',
                '& .MuiSwitch-thumb': {
                  color: colorStyles.checked.thumb,
                },
                '& + .MuiSwitch-track': {
                  backgroundColor: colorStyles.checked.track,
                  opacity: 1,
                },
              },
              // Disabled + Unchecked
              '&.Mui-disabled': {
                '& .MuiSwitch-thumb': {
                  color: colorStyles.disableUnchecked.thumb,
                },
                '& + .MuiSwitch-track': {
                  opacity: 1,
                  backgroundColor: colorStyles.disableUnchecked.track,
                },
                // Disabled + Checked
                '&.Mui-checked': {
                  '& .MuiSwitch-thumb': {
                    color: colorStyles.disableChecked.thumb,
                  },
                  '& + .MuiSwitch-track': {
                    backgroundColor: colorStyles.disableChecked.track,
                  },
                },
              },
            },
            '& .MuiSwitch-thumb': {
              boxShadow: 'none',
              boxSizing: 'border-box',
              width: '20px',
              height: '20px',
            },
            '& .MuiSwitch-track': {
              borderRadius: 26 / 2,
              opacity: 1,
              transition: theme.transitions.create(['background-color'], {
                duration: 500,
              }),
            },
          };
        },
      },
    },
  },
});

export default theme.components;
